<!--
 * @Author: your name
 * @Date: 2021-01-29 11:12:49
 * @LastEditTime: 2021-03-05 11:50:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \credit_xy\src\views\ApplyMembership.vue
-->
<template>
  <div id="ApplyMembership">
    <el-row class="title">
      <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
        <img src="../assets/img/shanghai.png" alt="" />
      </el-col>
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <img src="../assets/img/主页 (1).png" alt="" />
        <el-link class="help" href="http://www.shanghaicredit.org/" :underline="false" target="_blank">官网首页</el-link>
      </el-col>
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <img src="../assets/img/adoutxh-top.png" alt="" />
        <el-link class="help" href="http://www.shanghaicredit.org/about.php" :underline="false" target="_blank">关于协会</el-link>
      </el-col>
    </el-row>
    <el-row>
      <img src="../assets/img/升级.png" alt="" style="width:100%;" />
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>
<style lang="less" scoped>
#ApplyMembership {
  .title {
    padding: 20px;
    background-color: #374e95;
    .help {
      color: #fff;
      display: inline-block;
      padding-left: 10px;
      cursor: pointer;
      font-size: 16px;
    }
    img {
      vertical-align: middle;
    }
  }
}
</style>
